module.exports = __webpack_public_path__ + "static/media/Lara-Hopkins.48761592.jpg";